import {useState, useEffect} from 'react';

const useTimer = () => {
  const [on, setOn] = useState(false);
  const [elapsedTime, setElapsedTime] = useState<number>(0);

  useEffect(() => {
    let interval: any;
    if (on) {
      interval = setInterval(
        () => setElapsedTime((prevElapsedtime) => prevElapsedtime + 30),
        30,
      );
    }
    return () => {
      interval && clearInterval(interval);
    };
  }, [on]);

  return {
    on,
    setOn,
    elapsedTime,
    setElapsedTime,
  };
};

const useStopwatch = () => {
  const {on, setOn, elapsedTime, setElapsedTime} = useTimer();

  const handleReset = () => {
    setOn(false);
    setElapsedTime(0);
  };

  return {
    on,
    elapsed: elapsedTime,
    set: (value: number) => setElapsedTime(value),
    reset: () => handleReset(),
    start: () => setOn(true),
    stop: () => setOn(false),
  };
};

export default useStopwatch;
